<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Datos Generales de Salida
              |  
              a.button.is-default.is-rounded.is-medium(@click="backPage")
                i.fas.fa-times
              br
              router-link.a.button.is-text.is-rounded.is-medium(to="/Inventario/Salidas")
                | Ver Salidas
            br
        .columns
          .column.is-6.is-vcentered
            .field
              label.label Selecciona el Área
                .control
                  input#area_Inst.is-checkradio(type='radio' v-model="area" value="1" name='sel_area' checked='checked')
                  label.is-size-6(for='area_Inst') Instrum.
                  input#area_Sist.is-checkradio(type='radio' v-model="area" value="3" name='sel_area')
                  label.is-size-6(for='area_Sist') Sist./Telec.
                  input#area_Admon.is-checkradio(type='radio' v-model="area" value="2" name='sel_area')
                  label.is-size-6(for='area_Admon') Admón.
          .column.is-3
            .field
              label.label Destino
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="ubicacionSel")
                    option(v-for="ubi in ubicaciones" :key="ubi.id" :value="ubi") {{ ubi.nombre }}
                .icon.is-small.is-left
                  i.fas.fa-map-pin
          .column.is-3
            .field
              label.label Oficina
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="oficinaSelected")
                    option(v-for="data in almacenesFilter" :value="data" :key="data.id") {{ data.oficina }}
                .icon.is-small.is-left
                  i.fas.fa-tools
        .columns
          .column.is-3
            .field
              label.label Traslada
              .control
                Typeahead(:options="usuarios" :optionSelect="usuarioTras" :tema="typeTipos" v-model="usuarioTras")
          .column.is-3
            .field
              label.label Recibe
              .control
                Typeahead(:options="usuarios" :optionSelect="usuarioRecibe" :tema="typeTipos" v-model="usuarioRecibe")
        .columns(v-show="Object.keys(datosFaltantes).length > 0")
          .column.is-12
            .notification
              .field.is-grouped.is-grouped-multiline
                .control(v-for="datosF in datosFaltantes")
                  .tags
                    span.tag.is-danger.is-light {{ datosF }}
        .columns
          .column.is-one-quarter.is-offset.one-quarter
            a.button.is-black.is-rounded.is-medium(@click="checkForm") Guardar
</template>


<script>
import Loader from '../shared/Loader.vue'
import NavBarInventario from './layout/NavBarInventario.vue'
import InventarioServices from '../../services/inventario/inventario'
import usuariosServices from '../../services/usuarios/usuarios'
import Typeahead from './Typeahead.vue'
import { evall } from '../../configSystem'
const Cryptr = require('cryptr')
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'SalidaNueva',
  components: { Loader, NavBarInventario, Typeahead },
  data () {
    return {
      isLoading: true,
      area: null,
      recibe: '',
      oficina: '',
      autoriza: '',
      usuarios_Recibe: [],
      usuarios_Autoriza: [],
      isEditing: false,
      usuarios: [],
      typeTipos: '',
      usuarioTras: {},
      usuarioRecibe: {},
      datosFaltantes: [],
      ubicaciones: [],
      ubicacionSel: null,
      oficinaSelected: null,
      itemsGuardados: 0,
      allOficinas: [],
      idSalida: '',
      myObjSalida: {},
      fechaRegSalida: '',
      almacenes: [],
      almacenesFilter: [],
      origen: {},
    }
  },
  watch: {
    ubicacionSel() {
      this.almacenesFilter = this.almacenes.filter( ofi => ofi.id_ubicacion == this.ubicacionSel.id)
      const ubi = this.ubicacionSel.nombre === 'CORPORATIVO' ? 'CORPO' : this.ubicacionSel.nombre
      this.usuarioRecibe = this.usuarios.find( user => user.text === ubi)
    },
    area() {
      this.obtenerJefe()
    }
  },
  methods: {
    iniciarComponente () {
      this.obtenerUbicaciones()
    },
    obtenerUsuarios () {
      usuariosServices.getUsuarios()
        .then(res => {
          if (res.length > 0) {
              let uRecibe = res.filter(user => user.id !== '1538165924968' && user.id !== '1565972235101' && user.id !== '1556122430935' && parseInt(user.categoria) < 5)
              // let uAutoriza = res.filter(user => user.categoria === '2' || user.cargo ==='002' )
              let uAutoriza = res.filter(user => parseInt(user.categoria) == 0 && user.puesto !== '000' || parseInt(user.categoria) == 2 && user.departamento === '1' || parseInt(user.categoria) == 2 && user.departamento === '3')

              if (uRecibe.length > 0) {
              
                uRecibe.forEach(element => {
                  let tipoObj = {}
                  tipoObj = {
                    id: element.id,
                    text: `${element.nombre}`
                  }
                  this.usuarios.push(tipoObj)
                })
              }

              this.usuarios_Recibe = uRecibe
              this.usuarios_Autoriza = uAutoriza
              this.isLoading = false
              this.obtenerJefe()
            } else {
              this.isLoading = false
            }
        })
    },
    checkForm () {
      this.datosFaltantes = []
      if (this.area && this.ubicacionSel && this.oficinaSelected && Object.keys(this.usuarioRecibe).length > 0 && Object.keys(this.usuarioTras).length > 0) {
        this.saveSalida()
      } else {
        
        if (!this.area) {
          this.datosFaltantes.push('El Área es requerida.')
        }
        if (!this.ubicacionSel) {
          this.datosFaltantes.push('El Ubicación es requerido.')
        }
        if (!this.oficinaSelectedl) {
          this.datosFaltantes.push('La Oficina es requerida.')
        }

        if (Object.keys(this.usuarioTras).length == 0) {
          this.datosFaltantes.push('El Usuario que traslada es requerido.')
        }

        if (Object.keys(this.usuarioRecibe).length == 0) {
          this.datosFaltantes.push('El Usuario que recibe es requerido.')
        }

      }
    },
    saveSalida () {
      this.isLoading = true
      let ahora = moment()
      let fechaI = ahora.startOf('month').format('YYYY-MM-DD')
      let fechaF = ahora.endOf('month').format('YYYY-MM-DD')
      
      InventarioServices.countSalidas(fechaI, fechaF)
        .then(res => {
          
          let hoy = moment()
          let month = hoy.format('MM')
          let year = hoy.format('YY')
          
          this.fechaRegSalida = moment().format('YYYY-MM-DD HH:mm:ss')

          switch (true) {
            case parseInt(res[0].total) < 10:
              this.idSalida = `DUCTER-SALIDA-${year}${month}_00${res[0].total}`
              break
            case parseInt(res[0].total) < 100:
              this.idSalida = `DUCTER-SALIDA-${year}${month}_0${res[0].total}`
              break
            case parseInt(res[0].total) < 1000:
              this.idSalida = `DUCTER-SALIDA-${year}${month}_${res[0].total}`
              break
            default:
              this.idSalida = `DUCTER-SALIDA-${year}${month}_00${res[0].total}`
              break
          }

          let hash = ''
              
          InventarioServices.addSalida(this.idSalida, this.fechaRegSalida, this.userLogin.id, 
          this.userLogin.nombre, this.usuarioTras.id, this.usuarioTras.text, 
          this.usuarioRecibe.id, this.usuarioRecibe.text, this.autoriza.id, 
          this.autoriza.nombre, this.origen.ubicacion, this.ubicacionSel.nombre, this.origen.clave, 
          this.oficinaSelected.clave, this.area, hash)
            .then(resAdd => {

              if (resAdd.success) {
                this.myObjSalida = {
                  id_salida: this.idSalida,
                  fechaReg: this.fechaRegSalida,
                  id_entrega: this.userLogin.id,
                  entrega: this.userLogin.nombre,
                  id_traslada: this.usuarioTras.id,
                  traslada: this.usuarioTras.text,
                  id_recibe: this.usuarioRecibe.id,
                  recibe: this.usuarioRecibe.text,
                  id_autoriza: this.autoriza.id,
                  autoriza: this.autoriza.nombre,
                  origen: this.origen.ubicacion,
                  destino: this.ubicacionSel.nombre,
                  oficina: this.oficinaSelected.clave,
                  area: this.area,
                  estado: 1,
                  hash: hash
                }
                this.guardarItems()
                
              } else {
                this.displayToast('bubble',`Error: ${resAdd.respuesta}`, 'ban', 'OK')
              }
            })
            .catch((e)=> {
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
              this.isLoading = false
            })
        })
        .catch((err)=> {
          this.displayToast('bubble',`Error: ${err.message}`, 'ban', 'OK')
          this.isLoading = false
        })
    },
    guardarItems() {
      if (this.itemsGuardados == this.articulos_Salida.length) {
        this.displayToast('toasted-primary', 'La Salida se ha registrado correctamente.','done', 'ok')
        this.firmarSalida(this.myObjSalida)
      } else {
        let ahora1 = Date.now()
        let idMov = `${ahora1.toString()}${this.itemsGuardados}`
        let ahora2 = Date.now()
        let idUbi = `${ahora2.toString()}${this.itemsGuardados}u`
        
        InventarioServices.addItemToSalida(idMov,this.idSalida, idUbi, this.articulos_Salida[this.itemsGuardados].id,this.articulos_Salida[this.itemsGuardados].serie)
          .then(resItem => {
            if (resItem.success) {
              InventarioServices.addUbicacion(idUbi,this.articulos_Salida[this.itemsGuardados].id,this.fechaRegSalida,this.ubicacionSel.nombre,this.oficinaSelected.clave,this.userLogin.id,this.userLogin.nombre,this.usuarioRecibe.id, this.usuarioRecibe.text, '1')
                .then(resUbi => {
                  if (resUbi.success) { 
                    this.itemsGuardados = this.itemsGuardados + 1
                  } else {
                    this.itemsGuardados = this.itemsGuardados + 1
                    this.displayToast('bubble',resUbi.respuesta, 'ban', 'OK')
                  }
                  this.guardarItems()
                })
                .catch((e)=> {
                  this.itemsGuardados = this.itemsGuardados + 1
                  this.displayToast('bubble',e.message, 'ban', 'OK')
                  this.isLoading = false
                  this.guardarItems()
                })
            } else {
              this.itemsGuardados = this.itemsGuardados + 1
              this.displayToast('bubble',resItem.respuesta, 'ban', 'OK')
              this.guardarItems()
            }
          })
          .catch((e)=> {
            this.itemsGuardados = this.itemsGuardados + 1
            this.displayToast('bubble',e.message, 'ban', 'OK')
            this.isLoading = false
            this.guardarItems()
          }) 
      }
    },

    firmarSalida(salida) {
      this.$store.commit('firmarSalida', salida)
      this.$store.commit('limpiarArticulos_Salida')
      this.$router.push('/Inventario/Salida/Firma')
    },

    backInventario() {
      this.$store.commit('limpiarArticulos_Salida')
      this.$router.push('/Inventario')
    },
    
    obtenerJefe () {
      
      let objAutoriza = {}
      if (this.almacenSelect === "c") {
        console.log('almacen cede')
        switch (this.userLogin.ubicacion) {
          case 'TPA':
            console.log('TPA')
            objAutoriza = this.usuarios_Autoriza.find(u => u.puesto === '006')
            break
          case 'IRGE':
            console.log('IRGE')
            objAutoriza = this.usuarios_Autoriza.find(u => u.puesto === '004')
            break
          case 'CORP':
            console.log('CORP')
            objAutoriza = this.usuarios_Autoriza.find(u => u.puesto === '001')
            break
        
          default:
            objAutoriza = this.usuarios_Autoriza.find(u => u.puesto === '001')
            break
        }
        this.autoriza = Object.assign({}, this.autoriza, objAutoriza)
      } else {
        console.log('GIA')
        switch (this.area) {
          case '1':
            console.log('1')
            objAutoriza = this.usuarios_Autoriza.find( u => u.cargo === '210' )
            break
          case '2':
            console.log('2')
            objAutoriza = this.usuarios_Autoriza.find( u => u.puesto === '002' )
            break
          case '3':
            console.log('3')
            objAutoriza = this.usuarios_Autoriza.find( u => u.cargo === '230' )
            break
        
          default:
            objAutoriza = {}
            break
        }
        this.autoriza = Object.assign({}, this.autoriza, objAutoriza)
      }
    },
    encriptarId()  {
      try {
        const cryptr = new Cryptr(evall)
        const encryptedString = cryptr.encrypt(this.idSalida)
        return encryptedString
      } catch (error) {
        return error
      }
    },
    backPage() {
      this.$router.back()
    },
    displayToast(tema, text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: tema, 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    obtenerAlmacenes () {
        InventarioServices.getAlmacenesConsumibles('c')
        .then( data => {
          this.almacenes = data.map(this.convertirAlmacenes)
          this.obtenerAlmacenOrigen()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirAlmacenes (ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        id_ubicacion: parseInt(ofi.id_ubicacion),
        id_oficina: parseInt(ofi.id_oficina),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },
    obtenerAlmacenOrigen() {
      this.almacenes.map( alm => {
        const encontrado = alm.almacenistas.find( a => a.id_usuario === this.userLogin.id)
        if (encontrado) {
          this.origen = alm
        }
      })
      this.obtenerOficinas()
    },
    obtenerOficinas() {
      InventarioServices.getOficinas()
        .then( data => {
          this.allOficinas = data.map(this.convertirOficinas)
          this.obtenerUsuarios()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convertirOficinas(ofi) {
      return {
        ...ofi,
        id: parseInt(ofi.id),
        oficina: ofi.nombre,
        id_ubicacion: parseInt(ofi.id_ubicacion),
        inventario: parseInt(ofi.inventario) == 1 ? true : false,
      }
    },
    obtenerUbicaciones() {
      InventarioServices.getUbicaciones()
        .then( data => {
          this.ubicaciones = data.map(this.convetirUbicaciones)
          this.obtenerAlmacenes()
        })
        .catch((e) => {
          this.isLoading = false
          this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
        })
    },

    convetirUbicaciones (ubi) {
      return {
        ...ubi,
        id: parseInt(ubi.id)
      }
    },
  },
  created () {
    this.iniciarComponente()
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'articulos_Salida', 'almacenSelect'])
  }
}
</script>

<style lang="css" scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/SalidaNueva.vue